/* Gift card UI. Financial verification and checkout protection live in the eager guardian. */
(() => {
  function register() {
    if (!window.K9NativeOffer || !window.K9NativeGift?.quote || customElements.get('k9-gift-offer')) return;
    const { Base, state } = window.K9NativeOffer;
    const api = window.K9NativeGift;
    const { marker, selected, validateRule, validateCart, quota, cleanupPlan, activeRules, offers, refreshOffers, blockCheckout } = api;
    class GiftOffer extends Base {
      static requiresOptions = false;
      static validation() { return null; }
      nativeFields() { return {}; }
      synchronise() {}
      reflect() {}
      showFieldError() {}
      static items(config, mode, choices) {
        const gift = selected(config, 'secondary', choices.secondary);
        const primary = selected(config, 'primary', choices.primary);
        if (!gift || (mode === 'bundle' && !primary)) return null;
        const items = [{ id: gift.id, quantity: 1, properties: { [marker]: config.handle } }];
        if (mode === 'bundle') items.unshift({ id: primary.id, quantity: 1 });
        return items;
      }
      connectedCallback() {
        this.preparationActive = false;
        this.generation = (this.generation || 0) + 1;
        this.verified = null;
        this.selection = '';
        super.connectedCallback();
        try { validateRule(this.config); } catch { this.hidden = true; return; }
        const activate = () => { this.preparationActive = true; this.selection = ''; this.update(); };
        if (window.K9OfferActivation) window.K9OfferActivation(this, activate); else activate();
      }
      disconnectedCallback() { super.disconnectedCallback(); this.generation++; }
      update() {
        // A choice is a select or a group of radios; only the checked radio counts (as Base.update).
        for (const control of this.querySelectorAll('[data-variant]')) {
          if (control.type !== 'radio' || control.checked) this.draft.choices[control.dataset.variant] = control.value;
        }
        for (const container of this.querySelectorAll('[data-product-image]')) {
          const variant = selected(this.config, container.dataset.productImage, this.draft.choices[container.dataset.productImage]);
          const image = container.querySelector('img');
          if (image && variant?.image) { image.removeAttribute('srcset'); image.src = variant.image; }
        }
        const selection = JSON.stringify(this.draft.choices);
        if (selection !== this.selection) {
          this.selection = selection;
          this.verified = null;
          if (this.preparationActive !== false) void this.refreshQuote();
        }
        this.button.disabled = state.pending || !this.verified || this.draft.blocked || api.checkoutBlocked;
        this.button.setAttribute('aria-disabled', String(this.button.disabled));
        this.label.textContent = state.pending ? this.config.text.busy : this.defaultLabel;
        for (const input of this.querySelectorAll('input, select')) input.disabled = state.pending;
      }
      async storefront(query, variables) { return api.storefront.call(this, query, variables); }
      async quote(items, isCurrent = () => true) { return api.quote.call(this, items, isCurrent); }
      async refreshQuote() {
        if (this.preparationActive === false) return;
        const generation = this.generation, selection = this.selection, choices = { ...this.draft.choices };
        const revision = this.quoteRevision = (this.quoteRevision || 0) + 1;
        const isCurrent = () => this.isConnected && generation === this.generation
          && selection === this.selection && revision === this.quoteRevision;
        try {
          validateRule(this.config);
          const items = this.constructor.items(this.config, this.mode, choices);
          if (!items) throw Error('variant');
          let lines = items;
          if (this.mode === 'cart') {
            const cart = await Base.json(this.config.cartUrl);
            if (!isCurrent()) return;
            if (!cart.response.ok || quota(validateCart(cart.data, this.config.currency), this.config) < 1) throw Error('quota');
            lines = [...cart.data.items, ...items];
          }
          if (!isCurrent()) return;
          const quote = await this.quote(lines, isCurrent);
          if (!isCurrent()) return;
          this.verified = selection;
          const primary = selected(this.config, 'primary', this.draft.choices.primary);
          const gift = selected(this.config, 'secondary', this.draft.choices.secondary);
          const format = cents => new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: this.config.currency }).format(cents / 100);
          const total = this.querySelector('[data-total]'), original = this.querySelector('[data-original]');
          if (total) total.textContent = format(this.mode === 'bundle' ? quote.primaryTotal : 0);
          if (original) original.textContent = format(gift.price + (this.mode === 'bundle' ? primary.price : 0));
          this.hidden = false;
          this.update();
        } catch {
          if (isCurrent()) { this.verified = null; this.hidden = true; }
        }
      }
      async submit() {
        if (state.pending || this.draft.blocked || !this.verified || api.checkoutBlocked || Base.cartIsBusy()) return;
        const items = this.constructor.items(this.config, this.mode, this.draft.choices);
        if (!items) return;
        state.pending = true; state.version++;
        refreshOffers();
        let posted = false, confirmed = false, after;
        try {
          const baseline = await Base.json(this.config.cartUrl);
          if (!baseline.response.ok) throw Error('baseline');
          validateCart(baseline.data, this.config.currency);
          if (this.mode === 'cart' && quota(baseline.data, this.config) < 1) throw Error('quota');
          if (cleanupPlan(baseline.data, activeRules(this.config)).length) throw Error('stale-gift');
          await this.quote([...baseline.data.items, ...items]);
          posted = true;
          blockCheckout(true);
          const result = await Base.json(this.config.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
          const current = await Base.json(this.config.cartUrl);
          if (!current.response.ok) throw Error('cart');
          after = validateCart(current.data, this.config.currency);
          confirmed = items.every(item => Base.quantity(after, item) === Base.quantity(baseline.data, item) + item.quantity)
            && await api.verifyCart(after, activeRules(this.config))
            && !cleanupPlan(after, activeRules(this.config)).length;
          if (!confirmed) {
            const noneAdded = items.every(item => Base.quantity(after, item) === Base.quantity(baseline.data, item));
            this.draft.blocked = result.response.ok || !noneAdded;
            this.draft.message = this.config.text[this.draft.blocked ? 'uncertain' : 'rejected'];
          } else {
            this.draft.message = '';
            // Lot 4: anonymous acceptance count (k9-offre-mesure.js), only after full confirmation.
            (window.K9MesureFile ||= []).push({ element: this, total: baseline.data.total_price, currency: baseline.data.currency });
          }
        } catch {
          this.draft.blocked = posted;
          this.draft.message = this.config.text[posted ? 'uncertain' : 'beforeError'];
          if (posted) {
            try { const current = await Base.json(this.config.cartUrl); if (current.response.ok && Array.isArray(current.data.items)) after = current.data; } catch { /* No retry or blind undo. */ }
          }
        }
        try {
          if (posted && after && document.querySelector('cart-items')) { location.reload(); return; }
          const rendered = after && await this.redraw(after, confirmed ? items.at(-1).id : null);
          if (!rendered && confirmed) this.draft.message = this.config.text.added;
          const current = offers().find(e => e.key === this.key);
          current?.message(this.draft.message || '', this.draft.blocked || (confirmed && !rendered));
        } catch {
          this.message(confirmed ? this.config.text.added : this.draft.message, true);
        } finally {
          state.pending = false; state.version++;
          refreshOffers();
        }
      }
    }
    customElements.define('k9-gift-offer', GiftOffer);
  }
  register();
  document.addEventListener('DOMContentLoaded', register, { once: true });
})();
